/**
 * This file is to map delay condition , from and to BE structure, it should contain at least two functions, one that maps
 * from BE to FE structure, and the other one that maps from FE to BE structure
 */
import {hiddenActionEvents } from "assets/js/scenes/automations/containers/editor/EventsConfigs";
import {
	getEdge,
	getEndCoachmarkNode,
	getNextTarget,
	getShadowsForStep,
} from "assets/js/scenes/automations/containers/editor/utils/utils";

const parseBEAddContactToFE = (automation, mainStep, subStep, targetId) => {
	const events = [];
	events.push({
		id: mainStep.name,
		position: {
			x: 0,
			y: 0,
		},
		data: {
			name: hiddenActionEvents()[0].name,
			desc: hiddenActionEvents()[0].desc,
			type: "action",
			tileTitle: "app-automation-editor_events_action-addContact_tileTitle",
			id: mainStep.name,
			baseId: "addContact",
			selectedListId: mainStep.args.list_id,
			initialElement: false,
			deletable : false,
			shadows: getShadowsForStep(automation, mainStep.name),
		},
		type: "editorNode",
	});
	const links = [];
	if (targetId) {
		links.push(getEdge("custom", mainStep.name, targetId));
	} else {
		const endCoachmark = getEndCoachmarkNode(0, 0);
		events.push(endCoachmark);
		links.push(getEdge("custom", mainStep.name, endCoachmark.id));
	}
	return {
		events: events,
		links: links,
	};
};
const parseFEAddContactToBE = (FEEvent, connectedEdges, events) => {
	let shadows = [];
	let inTos = [];
	if (FEEvent.data.shadows) shadows = [...FEEvent.data.shadows];
	inTos = events
		.filter((e) => e.data.baseId == "loop")
		.filter((e) => e.data.goTo == FEEvent.id);
	if (inTos.length > 0) inTos = inTos.map((e) => `${e.id}_loop`);
	return {
		main: [
			{
				steps: [
					{
						name: `${FEEvent.id}`,
						action: "SubAutomation.Call",
						args: {
							sub_automation: FEEvent.id,
						},
						next: "end",
						shadows: shadows,
						inTos: inTos,
					},
				],
			},
		],
		sub: [
			{
				name: FEEvent.id,
				params: [],
				steps: [
					{
						name: FEEvent.id,

						action: "Contact.Add",
						args: {
							list_id: FEEvent.data.selectedListId,
							email: "${input.data.customer.email}",
						},
						next: getNextTarget(connectedEdges, events),
					},
					{
						args: {
							"input.data.contact": "${" +FEEvent.id +"_output.body.data}",
							"input.data.outputs": "${list.concat(input.data.outputs," + FEEvent.id + "_output)}",
							[`input.data.step_trigger.${FEEvent.id}`]:
							"${" + FEEvent.id + "_output}",
						},
						"name": "set_output",
						"action": "Variable.Set"
					}
				],
			},
		],
	};
};

export { parseBEAddContactToFE, parseFEAddContactToBE };
